import React from "react";

import { useForm } from "./context";

interface ProgressProps {
  scrollRef: React.Ref<HTMLElement>;
}

export default function Progress({ scrollRef }: ProgressProps) {
  const { currentPage, pages } = useForm();
  const totalPages = pages.length;
  return (
    <section className="progress" ref={scrollRef}>
      <span className="is-sr-only" role="status">
        Page {currentPage} of {totalPages}
      </span>
      <div className="container--slim" aria-hidden>
        <div className="steps">
          <div className="steps__progress" style={{ width: `${100 * ((currentPage - 1) / totalPages)}%` }}></div>
          <div className="steps__line"></div>
        </div>
      </div>
    </section>
  );
}
